import { useCallback } from 'react';
import { setAdvancedMode } from '@/domain/settings/service';
import { useSettings } from './useSettings';

/** `settings.ui.advancedMode`: only changes navigation and defaults. */
export function useAdvancedMode(): { advanced: boolean; set(v: boolean): Promise<void> } {
  const settings = useSettings();
  const set = useCallback((v: boolean) => setAdvancedMode(v), []);
  return { advanced: settings?.ui.advancedMode ?? false, set };
}
